import { PackageSearch } from "lucide-react";
import { fmtQty, packText, unitWord } from "@/lib/billsLanguage";

// Pack-size hint from the item text. Always a suggestion: nothing is applied until "Use".
export const PackSuggestion = ({ line, suggestion, onUse, onChange, busy }) => {
  const total = suggestion.multiplier * (Number(line.raw_quantity) || 1);
  const learned = suggestion.source === "learned_context";
  const pack = learned ? `${fmtQty(suggestion.multiplier)} ${unitWord(suggestion.base_unit)} in one ${line.raw_unit}` : packText(suggestion);
  return (
    <div className="mt-2 rounded-md border border-amber-200 bg-amber-50 p-3 space-y-3" data-testid={`pack-suggestion-${line.line_id}`}>
      <div className="flex gap-2 items-start">
        <PackageSearch size={18} className="text-amber-700 mt-0.5 shrink-0" aria-hidden />
        <div>
          <p className="text-[13px] text-amber-900" data-testid={`suggestion-kind-${line.line_id}`}>{learned ? "Last time you used" : "We found"}</p>
          {pack && <p className="text-[16px] font-semibold text-archival-primary" data-testid={`pack-text-${line.line_id}`}>{pack}</p>}
          <p className="text-[14px] text-archival-primary font-mono" data-testid={`pack-total-${line.line_id}`}>
            {fmtQty(total)} {unitWord(suggestion.base_unit)} total
          </p>
        </div>
      </div>
      <div className="flex flex-wrap gap-2">
        <button
          type="button"
          disabled={busy}
          onClick={() => onUse({ base_uom: suggestion.base_unit, multiplier: suggestion.multiplier })}
          data-testid={`pack-use-${line.line_id}`}
          className="h-12 px-4 rounded-md text-white text-[15px] font-semibold disabled:opacity-60"
          style={{ backgroundColor: "var(--action)" }}
        >
          Use {fmtQty(total)} {unitWord(suggestion.base_unit)}
        </button>
        <button
          type="button"
          disabled={busy}
          onClick={onChange}
          data-testid={`pack-change-${line.line_id}`}
          className="h-12 px-4 rounded-md border border-[#E4E0D8] bg-white text-[15px] font-medium text-archival-primary"
        >
          Change
        </button>
      </div>
    </div>
  );
};
